import type {Color} from "react-aria-components";

import {formatHsl} from "culori";
import {parseColor} from "react-aria-components";

import {DEFAULT_COLOR} from "../constants";

/* -------------------------------------------------------------------------------------------------
 * Safe Color Parser
 * -----------------------------------------------------------------------------------------------*/

export function safeParseColor(color: string | Color): Color {
  try {
    if (typeof color === "string") {
      if (color.startsWith("oklch")) {
        const hsl = formatHsl(color);

        if (!hsl) return parseColor(DEFAULT_COLOR);

        return parseColor(hsl);
      }

      return parseColor(color);
    }

    return color;
  } catch {
    return parseColor(DEFAULT_COLOR);
  }
}

/* -------------------------------------------------------------------------------------------------
 * Safe Default Value Parser
 * -----------------------------------------------------------------------------------------------*/

export function parseSafeDefaultValue(defaultValue: string | Color | undefined): Color {
  if (!defaultValue) return parseColor(DEFAULT_COLOR);
  if (typeof defaultValue !== "string") return defaultValue;

  const unsupportedFormats = ["oklab", "lab(", "lch(", "color("];

  if (unsupportedFormats.some((format) => defaultValue.toLowerCase().startsWith(format))) {
    return parseColor(DEFAULT_COLOR);
  }

  return safeParseColor(defaultValue);
}
